<template>
  <TransitionGroup
    name="list"
    tag="div"
    class="toast-wrapper"
  >
    <div
      v-for="toast in toastStore.toasts"
      :key="toast.id"
      class="toast"
      :class="{
        'is-success': toast.type === 'success',
        'is-error': toast.type === 'error',
        'is-warning': toast.type === 'warning',
      }"
    >
      {{ toast.message }}
    </div>
  </TransitionGroup>
</template>

<script setup>
import { useToastStore } from '@/stores/toast.js';

const toastStore = useToastStore();
</script>

<style lang="scss">
.toast-wrapper {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  .toast {
    width: max-content;
    background-color: #333333;
    background-color: var(--gray600, #051c3a);
    color: #ffffff;
    padding: 12px 24px;
    filter: opacity(0.95);
    border-radius: 9999999px;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,0.01);

    &.is-success {
      background-color: var(--systemSuccess, #4caf50);
    }
    &.is-error {
      background-color: var(--systemError, #f44336);
    }
    &.is-warning {
      background-color: var(--systemWarning, #ff9800);
    }
  }
}
</style>

<style>
.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.25s ease-in-out;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
